import { useEffect } from 'react';
import { useResponsive } from 'commons/components/Responsive';

function useFixedBulkHeaderScroll() {
  const { isMobile } = useResponsive();
  useEffect(() => {
    if (isMobile) return;
    const handleScroll = () => {
      const isScrolled =
        !!document.scrollingElement?.scrollTop &&
        document.scrollingElement?.scrollTop > 160;

      const bulkHeader = document.getElementsByClassName(
        'nimbus--data-table__bulk-actions',
      )[0];
      if (!bulkHeader) return;
      bulkHeader.classList.toggle('fixed-to-top', isScrolled);
    };

    const listener = () => handleScroll();
    document.addEventListener('scroll', listener);

    return () => {
      document.removeEventListener('scroll', listener);
    };
  }, [isMobile]);
}

export default useFixedBulkHeaderScroll;
